import React, {useContext, useEffect, useState} from 'react';
import { useHistory ,useLocation} from 'react-router-dom';
import Spinner from "../common/Spinner";
import { DataGrid, GridColumn  } from 'rc-easyui';
import {Button, Form, Label} from "semantic-ui-react";

import {confirmAlert} from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import ApiUtils from "../../helper/ApiUtils"; // Import css

const StylePage_list = ({clientList,LanguageList,List,total,CallToUpdate}) => {
    const history = useHistory();
    const location = useLocation();

    const [loading,setloading] = useState(false);


    //網址判斷
    useEffect(() => {

    }, [location]);


    return <div className=' pb-2 position-relative' >

        {(loading===true)?<Spinner/>:<div className="m-4">

            <DataGrid
                style={{ height: `${window.innerHeight-300}px` }}
                data={List}
                virtualScroll
                total={total}
                pageSize={20}
            >
                <GridColumn field="fStyleId" title="Id" width={30} sortable/>
                <GridColumn field="fTemplatename" title="Template name" sortable/>
                <GridColumn field="fFrameSplit" title="Frame Split"  width={80} sortable/>
                <GridColumn field="fFPS" title="FPS"  width={60} sortable/>
                <GridColumn field="fClientId" title="Client"   sortable render={({ row }) => {

                    const {fClientId} = row;
                    let cArray = clientList.filter(data=>data['fId']===fClientId);

                    if(cArray.length > 0){
                        // let fDueDateString = TimeUtils.setTaiwan(fDueDate);
                        const dataObj = cArray[0];
                        console.log(dataObj); 
                        return  dataObj['fName'];
                    }else{ 
                        return  "";
                    }
                    
                }}/>
                <GridColumn field="fLanguages" title="Languages"   sortable render={({ row }) => {

                    const {fLanguages} = row;

                    if(JSON.stringify(fLanguages) === 'null'){

                        return '';
                    }else{
                        const lArray = `${fLanguages}`.split(',');

                        let btn = [];
                        lArray.map((qdata,index)=>{

                            let dataArray = LanguageList.filter(data=>parseFloat(data["fId"])===parseFloat(qdata));

                            const dataObj = dataArray[0];
                            btn.push(<Button
                                className="mb-2"
                                key={index}
                                size='mini'
                                color={'blue'}

                            >{dataObj['fName']}
                            </Button>);
                        });
                        return  btn;
                    }


                }}/>


                <GridColumn field="fAllowPositioningType" title="Action" sortable  render={({ row }) => {
                    const {fStyleId} = row

                    return  <div className="p-2">
                        <Button color='orange' size="small" onClick={()=>{

                            CallToUpdate(fStyleId);

                        }} >Edit</Button>
                        <Button color='red' size="small" onClick={()=>{
                            confirmAlert({
                                title: 'Confirm to delete',
                                message: '',
                                buttons: [
                                    {
                                        label: 'Yes',
                                        onClick:async () => {

                                            await ApiUtils.post_sql(`${ApiUtils.post_Style_DeleteStyle}`,{fStyleId:fStyleId});

                                            window.location.reload();

                                        }
                                    },
                                    {
                                        label: 'No'
                                    }
                                ]
                            });
                        }}>Detele</Button>
                    </div>
                }}/>


            </DataGrid>

        </div>}
    </div>;
};

export default StylePage_list;



// WEBPACK FOOTER //
// ./src/components/Style/StylePage_list.js